<template>
  <div class="login-background">
    <title>Login</title>
    <el-form>
      <div>
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-bottom: 40px"
        />
      </div>
      <div>
        <div class="div_login">
          <input
            v-model="username"
            placeholder="Username"
            maxlength="40"
            class="input_username"
            autocomplete="off"
          />
        </div>
        <br />
        <div class="div_login">
          <input
            v-model="password"
            placeholder="Password"
            maxlength="50"
            type="password"
            class="input_password"
            autoComplete="new-password"
            @keyup.enter="Login"
          />
        </div>
        <el-form-item>
          <div style="margin-top: 20px"></div>
          <el-button class="login-button" @click="Login">Login</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>


<script>
export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  created() { 
    this.SSOLogin();
    // var code= new URL(location.href).searchParams.get('code'); 
    // if(code!==null)
    // {
    //   this.$api
    //     .post("/Auth/AdidasAccountLogin", {
    //       code: code,
    //     })
    //     .then((res) => {
    //       if (res.data.status == false) {
    //         this.$message({
    //           type: "error",
    //           message: res.data.message,
    //         });
    //         return false;
    //       } else {
    //         this.$store.commit("saveToken", res.data.content); //保存 token
    //         //this.$router.push("/ApprovalIndex");   
    //         window.open(window.location.origin+"#/ApprovalIndex",'_self');         
    //       }
    //     })
    //     .catch((res) => {
    //       this.$router.push({ path: "/" });
    //     });
    // }else{
    //   this.GetCode();
    // }
  },  
  
  methods: {
    Login() {
      //var password = this.RSAencrypt(this.password);
      var password = this.password;

      this.$api
        .post("/Auth/Token", {
          username: this.username,
          password: password,
        })
        .then((res) => {
          if (res.data.status == false) {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          } else {
            this.$store.commit("saveToken", res.data.content); //保存 token
            this.$router.push({ path: "/ApprovalIndex" });            
          }
        })
        .catch((res) => {
          this.$router.push({ path: "/" });
        });
    },
    RSAencrypt(pas) {
      debugger;
      var pass = this.$getRsaCode(pas);
      return pass;
    },
    GetCode(){
       this.$api.get("/Auth/GetCode/", {}, res => {})
       .then((res) => {
          if (res.data.success) {
            var data = res.data.response;
            var Client_ID = data.clientID;
            var Tenant_ID = data.tenantID;
            var ServerAddresses = data.serverAddresses;
            let date = new Date();

            var year = date.getFullYear().toString();
            var month = (date.getMonth() + 1).toString();
            var dates = date.getDate().toString();

            var datesend = year + month + dates;
            var url = ServerAddresses +
              Tenant_ID +
              '/oauth2/v2.0/authorize?' +
              'client_id=' +
              Client_ID +
              '&response_type=code' +
              '&response_mode=query' +
              '&scope=openid' +
              '&state=12345' +
              '&nonce=' +
              datesend +
              +'&prompt=select_account';  
            window.open(url, '_self');
          } 
        })        
    },
    SSOLogin(){
      var code= new URL(location.href).searchParams.get('code'); 
      if(code!==null)
      {
        this.$api
          .post("/Auth/AdidasAccountLogin", {
            code: code,
          })
          .then((res) => {
            if (res.data.status == false) {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            } else {
              this.$store.commit("saveToken", res.data.content); //保存 token
              //this.$router.push("/ApprovalIndex");   
              window.open(window.location.origin+"#/ApprovalIndex",'_self');         
            }
          })
          .catch((res) => {
            this.$router.push({ path: "/" });
          });
      }else{
        this.GetCode();
      }
    }
  },
};
</script>
<style scoped>
.el-input {
  width: 390px;
}
.login-background {
  background: url("../assets/images/login_background.png") no-repeat;
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.login-button {
  width: 390px;
  margin-top: 31px;
  height: 58px;
  font-size: 24px;
  border-radius: 0px;
  border: 0px;
  background: #ff8000;
  color: white;
}
.div_login {
  margin: 0 auto;
  width: 390px;
  height: 60px;
  line-height: 60px;
  background: rgba(255, 255, 255, 0.21);
}
.input_username {
  width: 390px;
  height: 60px;
  line-height: 60px;
  border-radius: 0px;
  font-size: 18px;
  color: #f9f9f9;
  box-sizing: border-box;
  padding: 0 15px;
  border: none;
  -webkit-appearance: none; /*去除阴影边框*/
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*点击高亮的颜色*/
  background: url("../assets/images/user.png") no-repeat scroll 350px center
    transparent;
  background-size: 26px 26px;
}
.input_password {
  width: 390px;
  height: 60px;
  line-height: 60px;
  border-radius: 0px;
  font-size: 18px;
  color: #f9f9f9;
  box-sizing: border-box;
  padding: 0 15px;
  border: none;
  -webkit-appearance: none; /*去除阴影边框*/
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*点击高亮的颜色*/
  background: url("../assets/images/password.png") no-repeat scroll 350px center
    transparent;
  background-size: 26px 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue